import { useState, useEffect } from 'react';

import axios from 'axios';
import routes from 'app/routes';

export default function useToken() {
  const [token, setToken] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.heygen.token)
      .then((response) => {
        setToken(response.data.data.token);
      });
  }, []);

  return token;
}
